module.exports = __webpack_public_path__ + "img/vet_thumbnail.24574e00.jpg";